import React, { useState, useEffect } from 'react';
import axios from 'axios'; // or use fetch
import API_BASE_URL from '../config';
import { ClipLoader } from 'react-spinners';

const Aboutsection = () => {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAboutData();
  }, []);

  const fetchAboutData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}home/info`);

      if (response.data.success) {
        setAboutData(response.data.data);
      } else {
        setError("Failed to fetch about information");
      }
    } catch (err) {
      setError("Error fetching about information");
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Loading state
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
        }}
      >
        <ClipLoader size={45} />
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <section className="about-section py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
    <section className="innerbanner"></section>
    <section className="staticpagecontainer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {aboutData?.about_us ? (
              <div 
                dangerouslySetInnerHTML={{ 
                  __html: aboutData.about_us 
                }} 
              />
            ) : (
              <div className="text-center">
                <p className="text-muted">
                  No about content available yet.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                  Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
                </p>
                <p>
                  Nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in 
                  reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Aboutsection;